// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file config/config_response.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file config/config_response.proto.
 */
export const file_config_config_response: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Chxjb25maWcvY29uZmlnX3Jlc3BvbnNlLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCJ+CiVHZXRDYWxlbmRhckludGVncmF0aW9uRW5hYmxlZFJlc3BvbnNlEk0KB3N1Y2Nlc3MYASABKAsyOi5jb20uZ2VtLmJmZi5jb250cmFjdC5HZXRDYWxlbmRhckludGVncmF0aW9uRW5hYmxlZFN1Y2Nlc3NIAEIGCgR0eXBlIjkKJEdldENhbGVuZGFySW50ZWdyYXRpb25FbmFibGVkU3VjY2VzcxIRCglpc0VuYWJsZWQYASABKAgidgohR2V0RTJlZUludGVncmF0aW9uRW5hYmxlZFJlc3BvbnNlEkkKB3N1Y2Nlc3MYASABKAsyNi5jb20uZ2VtLmJmZi5jb250cmFjdC5HZXRFMmVlSW50ZWdyYXRpb25FbmFibGVkU3VjY2Vzc0gAQgYKBHR5cGUiNQogR2V0RTJlZUludGVncmF0aW9uRW5hYmxlZFN1Y2Nlc3MSEQoJaXNFbmFibGVkGAEgASgIQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw'
  );

/**
 * @generated from message com.gem.bff.contract.GetCalendarIntegrationEnabledResponse
 */
export type GetCalendarIntegrationEnabledResponse =
  Message<'com.gem.bff.contract.GetCalendarIntegrationEnabledResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetCalendarIntegrationEnabledResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetCalendarIntegrationEnabledSuccess success = 1;
           */
          value: GetCalendarIntegrationEnabledSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetCalendarIntegrationEnabledResponse.
 * Use `create(GetCalendarIntegrationEnabledResponseSchema)` to create a new message.
 */
export const GetCalendarIntegrationEnabledResponseSchema: GenMessage<GetCalendarIntegrationEnabledResponse> =
  /*@__PURE__*/
  messageDesc(file_config_config_response, 0);

/**
 * @generated from message com.gem.bff.contract.GetCalendarIntegrationEnabledSuccess
 */
export type GetCalendarIntegrationEnabledSuccess =
  Message<'com.gem.bff.contract.GetCalendarIntegrationEnabledSuccess'> & {
    /**
     * @generated from field: bool isEnabled = 1;
     */
    isEnabled: boolean;
  };

/**
 * Describes the message com.gem.bff.contract.GetCalendarIntegrationEnabledSuccess.
 * Use `create(GetCalendarIntegrationEnabledSuccessSchema)` to create a new message.
 */
export const GetCalendarIntegrationEnabledSuccessSchema: GenMessage<GetCalendarIntegrationEnabledSuccess> =
  /*@__PURE__*/
  messageDesc(file_config_config_response, 1);

/**
 * @generated from message com.gem.bff.contract.GetE2eeIntegrationEnabledResponse
 */
export type GetE2eeIntegrationEnabledResponse =
  Message<'com.gem.bff.contract.GetE2eeIntegrationEnabledResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetE2eeIntegrationEnabledResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetE2eeIntegrationEnabledSuccess success = 1;
           */
          value: GetE2eeIntegrationEnabledSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetE2eeIntegrationEnabledResponse.
 * Use `create(GetE2eeIntegrationEnabledResponseSchema)` to create a new message.
 */
export const GetE2eeIntegrationEnabledResponseSchema: GenMessage<GetE2eeIntegrationEnabledResponse> =
  /*@__PURE__*/
  messageDesc(file_config_config_response, 2);

/**
 * @generated from message com.gem.bff.contract.GetE2eeIntegrationEnabledSuccess
 */
export type GetE2eeIntegrationEnabledSuccess =
  Message<'com.gem.bff.contract.GetE2eeIntegrationEnabledSuccess'> & {
    /**
     * @generated from field: bool isEnabled = 1;
     */
    isEnabled: boolean;
  };

/**
 * Describes the message com.gem.bff.contract.GetE2eeIntegrationEnabledSuccess.
 * Use `create(GetE2eeIntegrationEnabledSuccessSchema)` to create a new message.
 */
export const GetE2eeIntegrationEnabledSuccessSchema: GenMessage<GetE2eeIntegrationEnabledSuccess> =
  /*@__PURE__*/
  messageDesc(file_config_config_response, 3);
